import React from "react";
//#region types
import { SupportIssuesListMessageProps } from "models/propTypes/supportPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const SupportIssuesListMessage: React.FC<SupportIssuesListMessageProps> = (props) => {
  const { title, latestMessage } = props;

  return (
    <>
      <Grid container item direction="row" spacing={1}>
        {/* {isUnread && (
          <Grid item>
            <span className={cssExports.unreadIndicator}></span>
          </Grid>
        )} */}
        <Grid item className={cssExports.textBlack}>
          {title}
        </Grid>
      </Grid>
      <Grid item className={clsx(cssExports.textSmall, cssExports.singleLineText)}>
        {latestMessage}
      </Grid>
    </>
  );
};

export default SupportIssuesListMessage;
